(function ($, undefined) {

    'use strict';

    var handleClickDayEvent = function () {
        var t = $(this);

        if (t.hasClass('hover') && !$('html').hasClass('mobile')) {
            window.location.href = $(this).attr('data-url');
        } else if (t.hasClass('forward') && !$('html').hasClass('mobile')) {
            window.location.href = $(this).attr('data-url');
        } else {
            showDayEvent(t);
        }
    };
    
    var showDayEvent = function (dayCtn) {
        var t;
        dayCtn.length !== undefined ? t = dayCtn : t = $(this);
        var calendarOuter = t.closest('.calendar-home-cal-ctn');

        if (t.hasClass('selected') || calendarOuter.hasClass('animating')) {
            return;
        }

        calendarOuter.addClass('animating');

        var day = parseInt(t.find('.home-calendar-day-number').html());
        var id = t.attr('data-id');
        var version2 = false;
        var eventInfosCtn = calendarOuter.find('.home-calendar-one-event-right-side .calendar-home-event-infos-ver2');
        if (eventInfosCtn.length !== 0) {
            version2 = true;
        } else {
            eventInfosCtn = calendarOuter.find('.home-calendar-one-event-right-side .calendar-home-event-infos');
        }
        calendarOuter.find('.home-calendar-day.selected').removeClass('selected');
        t.addClass('selected');

        calendarOuter.find('.day-to-replace').html(day);
        if (calendarOuter.find('.day-suffix-to-replace').length) {
            var suffix = 'th';

            if (day % 10 === 1 && day % 100 !== 11) {
                suffix = 'st';
            } else if (day % 10 === 2 && day % 100 !== 12) {
                suffix = 'nd';
            } else if (day % 10 === 3 && day % 100 !== 13) {
                suffix = 'rd';
            }
            calendarOuter.find('.day-suffix-to-replace').html(suffix);
        }
        if (eventInfosCtn.attr('data-id') !== id) {
            eventInfosCtn.fadeOut(function () {
                if (version2) {
                    $('.calendar-home-event-infos-ver2').slick('unslick');
                    eventInfosCtn.html($('.calendar-home-event-infos-ver2[data-id=' + id + ']').html());
                    $('.calendar-home-event-infos-ver2').slick({
                        infinite: true,
                        autoplay: true,
                        autoplaySpeed: 2000,
                        nextArrow: '<button class="event-slider-arrows event-slider-next" />',
                        prevArrow: '<button class="event-slider-arrows event-slider-prev" />'
                    });
                    $('.calendar-home-event-infos-ver2').resize();
                } else {
                    eventInfosCtn.html($('.calendar-home-event-infos[data-id=' + id + ']').html());
                }
                eventInfosCtn.attr('data-id', id);
                eventInfosCtn.fadeIn();

                if (calendarOuter.find('.home-cal-event-ctn').hasClass('hide')) {
                    if (version2) {
                        calendarOuter.find('.home-cal-event-ctn').slideUp(function () {
                            $(this).removeClass('hide');
                            calendarOuter.removeClass('animating');
                            $('.calendar-home-event-infos-ver2').slick("refresh");
                        });
                    } else {
                        calendarOuter.find('.home-cal-event-ctn').slideDown(function () {
                            $(this).removeClass('hide');
                            calendarOuter.removeClass('animating');
                        });
                    }

                } else {
                    calendarOuter.removeClass('animating');
                }
            });
        } else {
            calendarOuter.removeClass('animating');
        }
    };

    var init = function () {
        $('.home-calendar-day.has-event').click(handleClickDayEvent);
        $('.home-calendar-day.has-event.hover').mouseover(showDayEvent);
    };
    $('.calendar-home-event-infos-ver2').slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        autoplaySpeed: 2000,
        nextArrow: '<button class="event-slider-arrows event-slider-next" />',
        prevArrow: '<button class="event-slider-arrows event-slider-prev" />'
    });
    $(window).ready(function () {
        init();
    });

})(jQuery);

